import styled from 'styled-components';

export const ChallengesGeneral = styled.div`
    margin-bottom: 12px;
    margin-top: 12px;
`;
